import "./Styles/experience.css"

export default function Experience(){
    return(
        <section class="education-section">
            <div id="resume-btn">
                <a href="../../../resume/Drake_Mitchell_Resume_GDD.pdf" download="DrakeMitchellPortfolio">
                    <button class="resume-btn download"> Download Resume </button>
                </a><br/>
            </div>
            <section/>
            <div id="education-text">
                <h2>Education</h2>
                <br/>
                <p ><strong id="university">University of Wisconsin - Stout </strong><br/>
                    <strong id="major">B.S. in Computer Science -<br/>Game Design and Development<br/></strong>
                    <i>Minor in Mathematics<br/>
                    2022-2026</i>
                </p>
                <br/>
            </div>
            <div id="skills-text">
                <h2>Skills & Relevant Coursework</h2>
                <br/>
                <p>
                    <strong>Game Design and Development</strong><br/> 
                    - Godot, Unreal 5, Unity<br/>
                    <p></p>
                <br/>
                <strong>Software Engineering</strong>  <br/>
                    – C#, C++, Python, Java, Ubuntu and C<br/>
                    <p></p><br/>
                    <strong>AGILE practices, Scrum & Git</strong><br/>
                    <p></p><br/>
                    <strong>Data Structures & Algorithms</strong><br/>
                    <p></p><br/>
                    <strong>Database Systems</strong><br/>
                    - MySQL Databases & .NET<br/>
                    <p></p><br/>
                    <strong>Web Development Front and Back End</strong>
                <br/>
                </p>
            </div>
        </section>
    )

}